import type { KottiField } from '../kotti-field/types'

export const KOTTI_FIELD_TEXT_AREA_SUPPORTS: KottiField.Supports = {
	autoComplete: true,
	borderless: true,
	clear: false,
	decoration: false,
	placeholder: true,
	tabIndex: true,
}
